import { render, staticRenderFns } from "./humburger.vue?vue&type=template&id=2ba0093d&"
import script from "./humburger.vue?vue&type=script&lang=js&"
export * from "./humburger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports